import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const cloudPrintManagementRoutes: Routes = [
    {
        path: advaniaServicesSegments.cloudPrintManagement,
        loadComponent: () =>
            import('./pages/cloud-print-management-page/cloud-print-management.page').then(
                (m) => m.CloudPrintManagementPage,
            ),
    },
];
